import React, { useState } from 'react'
import { InputNumber, Radio } from 'antd'
import styled from 'styled-components'
import { Popover, Toast } from '@seiue/ui'
import { EntryComponentsWrapper } from 'packages/theme'
import { AnswerProps } from './types'
import { useAnswersManagement } from './context'
import { PaperReview, ReviewResultEnum } from 'packages/sdks-next/growp'
import { precisionFormat } from 'packages/utils'

export const ReadOver: React.FC<{
  score?: string | null
  answer?: AnswerProps
  review?: PaperReview
}> = ({ score, answer, review }) => {
  const { onCreateReview, showScore } = useAnswersManagement()
  const [visible, setVisible] = useState<boolean>(false)
  const onChangeHalfRightScore = (v: string) => {
    if (v === undefined || v === '') {
      setVisible(false)
      return
    }
    const maxScore = score ? Number(score) : 0
    if (Number(v) > maxScore || Number(v) < 0) {
      Toast.warning(`请设置0~${precisionFormat(score)}之间的分数`)
      return
    }
    let result = ReviewResultEnum.HalfRight
    if (Number(v) === 0) {
      result = ReviewResultEnum.Wrong
    }
    if (Number(v) === maxScore) {
      result = ReviewResultEnum.Right
    }
    if (answer) {
      onCreateReview(answer, {
        answerId: answer.answerId,
        questionId: answer.questionId,
        submitterDomain: answer.submitterDomain,
        submitterId: answer.submitterId,
        gainedScore: String(v),
        result,
        id: review ? review.id : undefined,
      })
    }
    setVisible(false)
  }
  return (
    <Wrapper>
      <Radio.Group
        buttonStyle="outline"
        value={review?.result}
        onChange={(e) => {
          const result = e.target.value
          if (result === ReviewResultEnum.HalfRight && showScore) {
            return
          }
          if (answer) {
            let v = '0'
            if (result === ReviewResultEnum.Right) {
              v = score || '0'
            }
            onCreateReview(answer, {
              answerId: answer.answerId,
              questionId: answer.questionId,
              submitterDomain: answer.submitterDomain,
              submitterId: answer.submitterId,
              gainedScore: v,
              result,
              id: review ? review.id : undefined,
            })
          }
        }}
      >
        <Radio.Button value={ReviewResultEnum.Right}>
          <LabelWrapper>正确</LabelWrapper>
        </Radio.Button>
        <Popover
          visible={visible}
          destroyTooltipOnHide={true}
          content={
            <>
              {showScore ? (
                <EntryComponentsWrapper>
                  <PopoverContent>
                    <InputNumber
                      value={
                        review?.result === ReviewResultEnum.HalfRight
                          ? review?.gainedScore
                          : undefined
                      }
                      autoFocus={true}
                      stringMode
                      onBlur={(e) => {
                        onChangeHalfRightScore(e.target.value)
                      }}
                      onPressEnter={(e) => {
                        e.target?.blur()
                      }}
                    />
                    <div>满分{precisionFormat(score) || 0}分</div>
                  </PopoverContent>
                </EntryComponentsWrapper>
              ) : null}
            </>
          }
          trigger="click"
          placement="bottomLeft"
        >
          <Radio.Button value={ReviewResultEnum.HalfRight}>
            <LabelWrapper
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setVisible(true)
              }}
            >
              半对
            </LabelWrapper>
          </Radio.Button>
        </Popover>
        <Radio.Button value={ReviewResultEnum.Wrong}>
          <LabelWrapper>错误</LabelWrapper>
        </Radio.Button>
      </Radio.Group>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-left: 220px;
`

const LabelWrapper = styled.div`
  font-size: 14px;
  font-weight: normal;
`

const PopoverContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  height: 60px;
  border-radius: 8px;
  padding: 16px 20px;
  font-size: 12px;
  font-weight: normal;
  color: ${(props) => props.theme.text._2};
  &&& {
    .ant-input-number {
      width: 96px;
      height: 28px;
      & > .ant-input-number-input {
        height: 28px˝;
      }
    }
    .ant-input-number-input {
      height: 28px;
      line-height: 28px;
    }
  }
`
